var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reports"},[_c('vue-good-table',{attrs:{"mode":"remote","columns":_vm.columns,"rows":_vm.rows,"sort-options":{
      enabled: true,
    },"isLoading":_vm.isLoading,"styleClass":"vgt-table bordered","pagination-options":{
      enabled: true,
      mode: 'registros',
      position: 'top',
      perPage: 10,
      nextLabel: 'siguiente',
      prevLabel: 'anterior',
      rowsPerPageLabel: 'Filas por página',
      ofLabel: 'de',
      pageLabel: 'páginas', // for 'pages' mode
      allLabel: 'Todos',
    }},on:{"update:isLoading":function($event){_vm.isLoading=$event},"update:is-loading":function($event){_vm.isLoading=$event}},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'actions')?_c('span',[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.configRole(props)}}},[_c('font-awesome-icon',{attrs:{"icon":['fa', 'sliders-h']}})],1)]):_vm._e()]}}])}),_c('button',{on:{"click":_vm.restore}},[_vm._v("Reataurar")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }